<div class="m-3">
  <ul id="breadcrumb">
    <ng-container *ngFor="let breadcrumb of breadcrumbs; let i = index">
      <li>
        <a href="#" [routerLink]="breadcrumb.link">
          <mat-icon
            *ngIf="breadcrumb.icon && breadcrumb.iconSvg"
            [svgIcon]="breadcrumb.icon"
            class="material-icons mr-1"
          >
          </mat-icon>
          <mat-icon
            *ngIf="breadcrumb.icon && !breadcrumb.iconSvg"
            class="material-icons mr-1"
          >
            {{ breadcrumb.icon }}
          </mat-icon>
          <span class="fuente" *ngIf="breadcrumb.text">{{ breadcrumb.text }}</span>
        </a>
        <!-- Agregar "/" después de cada breadcrumb excepto el último -->
        <span class="divider-bread" *ngIf="i < breadcrumbs.length - 1"> / </span>
      </li>
    </ng-container>
  </ul>
</div>